// extracted by mini-css-extract-plugin
module.exports = {"BackBanner__Clickable":"BackBanner_BackBanner__Clickable__RnvdE","BackBanner":"BackBanner_BackBanner__hDXak","BackBanner__Container":"BackBanner_BackBanner__Container__Yg3nX"};